'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../../utils/getThemeProp.js');
require('../../utils/colors.js');
require('../../utils/dates.js');
require('../../utils/numbers.js');
require('../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../../utils/strings.js');
require('../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../../utils/safeFetch.js');
require('../../utils/dom.js');
var TableCell = _interopDefault(require('@material-ui/core/TableCell'));

var PromoterCell = styled__default(TableCell)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  background-color: #4c7cdf;\n  border-right: 1px solid white;\n  color: white;\n"], ["\n  background-color: #4c7cdf;\n  border-right: 1px solid white;\n  color: white;\n"])));
var NeutralCell = styled__default(TableCell)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  background-color: #12253f;\n  border-right: 1px solid white;\n  color: white;\n"], ["\n  background-color: #12253f;\n  border-right: 1px solid white;\n  color: white;\n"])));
var DetractorCell = styled__default(TableCell)(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  background-color: #ea5e57;\n  border-right: 1px solid white;\n  color: white;\n"], ["\n  background-color: #ea5e57;\n  border-right: 1px solid white;\n  color: white;\n"])));
var TableContainer = styled__default.div(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  .MuiTableCell-root {\n    border-bottom: 1px solid ", ";\n    border-right: 1px solid ", ";\n  }\n"], ["\n  .MuiTableCell-root {\n    border-bottom: 1px solid ", ";\n    border-right: 1px solid ", ";\n  }\n"])), getThemeProp('palette.divider', 'lightgray'), getThemeProp('palette.divider', 'lightgray'));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.DetractorCell = DetractorCell;
exports.NeutralCell = NeutralCell;
exports.PromoterCell = PromoterCell;
exports.TableContainer = TableContainer;
